import React, { useEffect } from 'react'
import { Header } from '../components'
import { useLazyGetRedevablesQuery } from '../redux/redevableService'
import { generateStatistiquesParTypeJSX, getDetailedTypeStatistics, getRedevableNumberByType, getRepartitionParTypeRedevance, getStatistiquesParType } from '../utils/calculRedevances'
import { useGetAnalyticsQuery } from '../redux/analytics'

const Report = () => {

  const [getRedevable, {data, isLoading, isError}] = useLazyGetRedevablesQuery()
  const {data : analyticData, isLoading: analyticIsLoading, isFteching: analyticIsFetching, isError: analyticIsError} = useGetAnalyticsQuery({page: 1, size: 10})

  

  useEffect(() => {
    getRedevable({page: 1, size: 1000})
   
  }, [])

  const stats = getRedevableNumberByType(data);
  const repartition = getRepartitionParTypeRedevance(data);
  console.log("Types:", stats.types);
  console.log("Total:", stats.total);
  const statistiques = getStatistiquesParType(data, 5500); // 5500 = total précédent pour exemple
  console.log("statistiques:", statistiques);

  const detailedStats = getDetailedTypeStatistics(data);
console.log("Types triés:", detailedStats.sortedTypes);
  return (

    <div className="m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl">
        <Header category="Page" title="Rapports" />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
           

           <div className="bg-white p-6 rounded-2xl shadow flex justify-between items-center">
             <div>
               <h3 className="text-gray-500">Montant Redevances</h3>
               <p className="text-2xl font-bold">{analyticData?.data[0]?.attributes.redevance_totale?.toLocaleString()} FCFA</p>
               <span className="text-green-500 text-sm font-semibold">+2.08%</span>
             </div>
             <div className="bg-blue-600 text-white p-4 rounded-xl">💰</div>
           </div>
         
           <div className="bg-white p-6 rounded-2xl shadow flex justify-between items-center">
             <div>
               <h3 className="text-gray-500">Total Redevables</h3>
               <p className="text-2xl font-bold">5,760</p>
               <span className="text-green-500 text-sm font-semibold">+1.22%</span>
             </div>
             <div className="bg-green-600 text-white p-4 rounded-xl">🏢</div>
           </div>
         
           {/* Ou utilisation personnalisée */}
           <div className="bg-white p-6 rounded-2xl shadow">
                <h3 className="text-gray-500 mb-2">Statistiques par Type</h3>
                <p className="text-2xl font-bold">
                    {statistiques?.total?.toLocaleString()} 
                    <span className={`${statistiques.growthColor} text-sm ml-2`}>
                        +{statistiques.growthPercentage}%
                    </span>
                </p>
                <div className="mt-4">
                    <ul className="space-y-2">
                        {statistiques?.topTypes?.map((item, index) => (
                            <li key={index} className="flex justify-between">
                                <span>{item.emoji} {item.displayName}</span>
                                <span className="font-bold">{item?.count?.toLocaleString()}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
         
           <div className="bg-white p-6 rounded-2xl shadow flex justify-between items-center">
             <div>
               <h3 className="text-gray-500">Redevances Payées</h3>
               <p className="text-2xl font-bold">{analyticData?.data[0]?.attributes.redevance_payer?.toLocaleString()} FCFA</p>
               <span className="text-green-500 text-sm font-semibold">+5.08%</span>
             </div>
             <div className="bg-green-600 text-white p-4 rounded-xl">✅</div>
           </div>
         
           <div className="bg-white p-6 rounded-2xl shadow flex justify-between items-center">
             <div>
               <h3 className="text-gray-500">Redevances Impayées</h3>
               <p className="text-2xl font-bold">{analyticData?.data[0]?.attributes.redevance_non_payer?.toLocaleString()} FCFA</p>
               <span className="text-red-500 text-sm font-semibold">-1.65%</span>
             </div>
             <div className="bg-red-600 text-white p-4 rounded-xl">❌</div>
           </div>
         
           <div className="bg-white p-6 rounded-2xl shadow">
                <h3 className="text-gray-500 mb-4">Répartition par Type de Redevance</h3>
                <div className="flex flex-wrap gap-4">
                    {repartition.map((item, index) => (
                        <div key={index} className={item.className}>
                            {item.emoji} {item.displayName}: {item.count}
                        </div>
                    ))}
                </div>
            </div>
         
           <div className="bg-white p-6 rounded-2xl shadow col-span-1 lg:col-span-3">
             <h3 className="text-gray-500 mb-4">Évolution des Redevances par Mois</h3>
             <div className="grid grid-cols-12 gap-2 items-end h-40">
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-20"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-32"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-24"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-36"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-28"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-40"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-32"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-24"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-36"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-20"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-28"></div>
               <div className="bg-blue-500 col-span-1 rounded-t-lg h-24"></div>
             </div>
             <div className="flex justify-between mt-2 text-gray-500 text-sm">
               <span>Jan</span><span>Fév</span><span>Mar</span><span>Avr</span>
               <span>Mai</span><span>Jun</span><span>Jul</span><span>Aoû</span>
               <span>Sep</span><span>Oct</span><span>Nov</span><span>Déc</span>
             </div>
           </div>
         </div>
    </div>
   
  )
}

export default Report
